// // src/pages/LeaveTypeMaster.tsx
// import React, { useState, useEffect, useMemo, useCallback } from 'react';
// import {
//     Container,
//     Row,
//     Col,
//     Card,
//     CardBody,
//     CardHeader,
//     Button,
//     Badge,
//     Modal,
//     ModalHeader,
//     ModalBody,
//     ModalFooter,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     Alert,
//     Spinner,
// } from 'reactstrap';
// import {
//     Plus,
//     Edit,
//     Trash2,
//     RefreshCw,
//     Eye,
//     CheckCircle,
//     XCircle,
// } from 'react-feather';
// import BreadCrumb from '../../Components/Common/BreadCrumb';
// import TableContainer from '../../Components/Common/TableContainer';
// import { format } from 'date-fns';
// import { toast } from 'react-toastify';
// import { apiClient } from '../../helpers/api_helper';

// // Types
// interface LeaveType {
//     id: number;
//     name: string;
//     short_name?: string;
//     is_paid: boolean;
//     color_hex?: string;
//     max_days_per_year?: number | string | null;
//     carry_forward: boolean;
//     requires_approval: boolean;
//     requires_attachment: boolean;
//     is_active: boolean;
//     sort_order: number;
//     description?: string;
//     created_at: string;
//     updated_at: string;
// }

// const LeaveTypeMaster: React.FC = () => {
//     // State
//     const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [showInactive, setShowInactive] = useState(false);

//     // Modal states
//     const [modal, setModal] = useState(false);
//     const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
//     const [selectedLeaveType, setSelectedLeaveType] = useState<LeaveType | null>(null);
//     const [formData, setFormData] = useState({
//         name: '',
//         short_name: '',
//         is_paid: true,
//         color_hex: '#3B82F6',
//         max_days_per_year: '' as string | number,
//         carry_forward: false,
//         requires_approval: true,
//         requires_attachment: false,
//         is_active: true,
//         sort_order: 0,
//         description: '',
//     });
//     const [submitting, setSubmitting] = useState(false);
//     const [formError, setFormError] = useState('');

//     // Delete modal
//     const [deleteModal, setDeleteModal] = useState(false);
//     const [deleting, setDeleting] = useState(false);
//     const [leaveTypeToDelete, setLeaveTypeToDelete] = useState<LeaveType | null>(null);

//     // View modal
//     const [viewModal, setViewModal] = useState(false);
//     const [viewingLeaveType, setViewingLeaveType] = useState<LeaveType | null>(null);

//     // Fetch leave types
//     const fetchLeaveTypes = useCallback(async () => {
//         setLoading(true);
//         setError('');

//         try {
//             const response = await apiClient.get(
//                 `/leave-types?include_inactive=${showInactive}`
//             );
//             console.log('leave types',response)
//             const data = response as LeaveType[];
//             setLeaveTypes(data || []);
//         } catch (error: any) {
//             console.error('Error fetching leave types:', error);
//             setError(error.message || 'Failed to fetch leave types');
//             toast.error('Failed to load leave types');
//         } finally {
//             setLoading(false);
//         }
//     }, [showInactive]);

//     // Initial fetch
//     useEffect(() => {
//         fetchLeaveTypes();
//     }, [fetchLeaveTypes]);

//     // Handle form input change
//     const handleInputChange = (
//         e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//     ) => {
//         const { name, value, type } = e.target;
//         const checked = (e.target as HTMLInputElement).checked;

//         setFormData(prev => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value,
//         }));
//     };

//     // Open add modal
//     const openAddModal = () => {
//         setModalMode('add');
//         setFormData({
//             name: '',
//             short_name: '',
//             is_paid: true,
//             color_hex: '#3B82F6',
//             max_days_per_year: '',
//             carry_forward: false,
//             requires_approval: true,
//             requires_attachment: false,
//             is_active: true,
//             sort_order: 0,
//             description: '',
//         });
//         setFormError('');
//         setModal(true);
//     };

//     // Open edit modal
//     const openEditModal = (leaveType: LeaveType) => {
//         setModalMode('edit');
//         setSelectedLeaveType(leaveType);
//         setFormData({
//             name: leaveType.name,
//             short_name: leaveType.short_name || '',
//             is_paid: leaveType.is_paid,
//             color_hex: leaveType.color_hex || '#3B82F6',
//             max_days_per_year:
//                 leaveType.max_days_per_year !== null &&
//                 leaveType.max_days_per_year !== undefined
//                     ? String(leaveType.max_days_per_year)
//                     : '',
//             carry_forward: leaveType.carry_forward,
//             requires_approval: leaveType.requires_approval,
//             requires_attachment: leaveType.requires_attachment,
//             is_active: leaveType.is_active,
//             sort_order: leaveType.sort_order ?? 0,
//             description: leaveType.description || '',
//         });
//         setFormError('');
//         setModal(true);
//     };

//     // Close modal
//     const closeModal = () => {
//         setModal(false);
//         setSelectedLeaveType(null);
//         setFormError('');
//     };

//     // Handle form submit
//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();

//         // Validate
//         if (!formData.name.trim()) {
//             setFormError('Leave type name is required');
//             return;
//         }
//         if (
//             formData.max_days_per_year !== '' &&
//             isNaN(Number(formData.max_days_per_year))
//         ) {
//             setFormError('Max days per year must be a number');
//             return;
//         }

//         setSubmitting(true);
//         setFormError('');

//         const payload = {
//             name: formData.name.trim(),
//             short_name: formData.short_name.trim() || undefined,
//             is_paid: formData.is_paid,
//             color_hex: formData.color_hex?.trim() || undefined,
//             max_days_per_year:
//                 formData.max_days_per_year === ''
//                     ? undefined
//                     : Number(formData.max_days_per_year),
//             carry_forward: formData.carry_forward,
//             requires_approval: formData.requires_approval,
//             requires_attachment: formData.requires_attachment,
//             is_active: formData.is_active,
//             sort_order: Number(formData.sort_order) || 0,
//             description: formData.description.trim() || undefined,
//         };

//         try {
//             if (modalMode === 'add') {
//                 await apiClient.post('/leave-types', payload);
//                 toast.success('Leave type created successfully!');
//             } else {
//                 await apiClient.put(
//                     `/leave-types/${selectedLeaveType?.id}`,
//                     payload
//                 );
//                 toast.success('Leave type updated successfully!');
//             }

//             closeModal();
//             fetchLeaveTypes();
//         } catch (error: any) {
//             console.error('Error saving leave type:', error);
//             setFormError(error.message || 'Failed to save leave type');
//             toast.error('Failed to save leave type');
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     // Handle delete
//     const openDeleteModal = (leaveType: LeaveType) => {
//         setLeaveTypeToDelete(leaveType);
//         setDeleteModal(true);
//     };

//     const confirmDelete = async () => {
//         if (!leaveTypeToDelete) return;

//         setDeleting(true);
//         try {
//             await apiClient.delete(`/leave-types/${leaveTypeToDelete.id}`);
//             toast.success('Leave type deleted successfully!');
//             setDeleteModal(false);
//             fetchLeaveTypes();
//         } catch (error: any) {
//             console.error('Error deleting leave type:', error);
//             toast.error(error.message || 'Failed to delete leave type');
//         } finally {
//             setDeleting(false);
//             setLeaveTypeToDelete(null);
//         }
//     };

//     // Handle restore
//     const handleRestore = async (leaveType: LeaveType) => {
//         try {
//             await apiClient.patch(`/leave-types/${leaveType.id}/restore`);
//             toast.success('Leave type restored successfully!');
//             fetchLeaveTypes();
//         } catch (error: any) {
//             console.error('Error restoring leave type:', error);
//             toast.error(error.message || 'Failed to restore leave type');
//         }
//     };

//     // Handle view
//     const handleView = (leaveType: LeaveType) => {
//         setViewingLeaveType(leaveType);
//         setViewModal(true);
//     };

//     // Format date
//     const formatDate = (dateString: string) => {
//         try {
//             return format(new Date(dateString), 'dd MMM yyyy HH:mm');
//         } catch {
//             return 'N/A';
//         }
//     };

//     // Format decimal
//     const formatDecimal = (value: number | string | null | undefined) => {
//         if (value === null || value === undefined || value === '') return '—';
//         const num = Number(value);
//         if (isNaN(num)) return '—';
//         return Number.isInteger(num) ? String(num) : num.toFixed(2);
//     };

//     // Status badge (is_active)
//     const getStatusBadge = (isActive: boolean) => {
//         return isActive ? (
//             <Badge color="success">
//                 <CheckCircle size={12} className="me-1" />
//                 Active
//             </Badge>
//         ) : (
//             <Badge color="warning">
//                 <XCircle size={12} className="me-1" />
//                 Inactive
//             </Badge>
//         );
//     };

//     // Paid / Unpaid badge
//     const getPaidBadge = (isPaid: boolean) => {
//         return isPaid ? (
//             <Badge color="primary">Paid</Badge>
//         ) : (
//             <Badge color="secondary">Unpaid</Badge>
//         );
//     };

//     // Color swatch
//     const getColorSwatch = (hex?: string) => {
//         if (!hex) return '—';
//         return (
//             <div className="d-flex align-items-center gap-2">
//                 <span
//                     style={{
//                         display: 'inline-block',
//                         width: 18,
//                         height: 18,
//                         borderRadius: 4,
//                         backgroundColor: hex,
//                         border: '1px solid rgba(0,0,0,0.15)',
//                     }}
//                 />
//                 <span className="text-muted small">{hex}</span>
//             </div>
//         );
//     };

//     // Table columns
//     const columns = useMemo(
//         () => [
//             {
//                 header: 'SI.No',
//                 accessorKey: 'id',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: (cell: any) => <strong>{cell.row.index + 1}</strong>,
//             },
//             {
//                 header: 'Name',
//                 accessorKey: 'name',
//                 cell: (cell: any) => (
//                     <span className="fw-semibold">{cell.getValue()}</span>
//                 ),
//             },
//             {
//                 header: 'Short',
//                 accessorKey: 'short_name',
//                 cell: (cell: any) => cell.getValue() || '—',
//             },
//             {
//                 header: 'Paid',
//                 accessorKey: 'is_paid',
//                 cell: (cell: any) => getPaidBadge(cell.getValue()),
//             },
//             {
//                 header: 'Color',
//                 accessorKey: 'color_hex',
//                 enableColumnFilter: false,
//                 cell: (cell: any) => getColorSwatch(cell.getValue()),
//             },
//             {
//                 header: 'Max Days/Year',
//                 accessorKey: 'max_days_per_year',
//                 enableColumnFilter: false,
//                 cell: (cell: any) => formatDecimal(cell.getValue()),
//             },
//             {
//                 header: 'Status',
//                 accessorKey: 'is_active',
//                 cell: (cell: any) => getStatusBadge(cell.getValue()),
//             },
//             {
//                 header: 'Actions',
//                 accessorKey: 'actions',
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: (cell: any) => {
//                     const leaveType = cell.row.original;
//                     return (
//                         <div className="d-flex gap-1">
//                             <Button
//                                 color="info"
//                                 size="sm"
//                                 title="View"
//                                 onClick={() => handleView(leaveType)}
//                             >
//                                 <Eye size={14} />
//                             </Button>
//                             <Button
//                                 color="primary"
//                                 size="sm"
//                                 title="Edit"
//                                 onClick={() => openEditModal(leaveType)}
//                             >
//                                 <Edit size={14} />
//                             </Button>
//                             {leaveType.is_active ? (
//                                 <Button
//                                     color="danger"
//                                     size="sm"
//                                     title="Delete"
//                                     onClick={() => openDeleteModal(leaveType)}
//                                 >
//                                     <Trash2 size={14} />
//                                 </Button>
//                             ) : (
//                                 <Button
//                                     color="success"
//                                     size="sm"
//                                     title="Restore"
//                                     onClick={() => handleRestore(leaveType)}
//                                 >
//                                     <RefreshCw size={14} />
//                                 </Button>
//                             )}
//                         </div>
//                     );
//                 },
//             },
//         ],
//         []
//     );

//     return (
//         <div className="page-content">
//             <Container fluid>
//                 <BreadCrumb title="Leave Type Master" pageTitle="Leave Types" />

//                 <Row>
//                     <Col lg={12}>
//                         <Card>
//                             <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//                                 <h5 className="card-title mb-0">Leave Types</h5>
//                                 <div className="d-flex gap-2">
//                                     <FormGroup check className="mb-0 d-flex align-items-center">
//                                         <Label check className="me-2 mb-0">
//                                             <Input
//                                                 type="checkbox"
//                                                 checked={showInactive}
//                                                 onChange={() =>
//                                                     setShowInactive(!showInactive)
//                                                 }
//                                             />
//                                             <span className="ms-1">Show Inactive</span>
//                                         </Label>
//                                     </FormGroup>
//                                     <Button
//                                         color="secondary"
//                                         size="sm"
//                                         onClick={() => fetchLeaveTypes()}
//                                         disabled={loading}
//                                     >
//                                         <RefreshCw size={14} className="me-1" />
//                                         Refresh
//                                     </Button>
//                                     <Button
//                                         color="primary"
//                                         size="sm"
//                                         onClick={openAddModal}
//                                     >
//                                         <Plus size={14} className="me-1" />
//                                         Add Leave Type
//                                     </Button>
//                                 </div>
//                             </CardHeader>

//                             <CardBody>
//                                 {error && (
//                                     <Alert color="danger" className="mb-3">
//                                         <i className="ri-error-warning-line align-middle me-2"></i>
//                                         {error}
//                                     </Alert>
//                                 )}

//                                 {loading ? (
//                                     <div className="text-center py-5">
//                                         <Spinner color="primary" className="me-2" />
//                                         <span>Loading leave types...</span>
//                                     </div>
//                                 ) : leaveTypes.length === 0 ? (
//                                     <div className="text-center py-5">
//                                         <i className="ri-calendar-check-line display-4 text-muted"></i>
//                                         <h5 className="mt-3">No leave types found</h5>
//                                         <p className="text-muted">
//                                             {showInactive
//                                                 ? 'No leave types match your filter criteria.'
//                                                 : "Click 'Add Leave Type' to create your first leave type."}
//                                         </p>
//                                     </div>
//                                 ) : (
//                                     <TableContainer
//                                         columns={columns}
//                                         data={leaveTypes}
//                                         customPageSize={10}
//                                         tableClass="table-striped"
//                                         theadClass="table-light"
//                                     />
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>

//             {/* Add/Edit Modal */}
//             <Modal isOpen={modal} toggle={closeModal} size="lg">
//                 <ModalHeader toggle={closeModal}>
//                     {modalMode === 'add' ? 'Add New Leave Type' : 'Edit Leave Type'}
//                 </ModalHeader>
//                 <ModalBody>
//                     {formError && (
//                         <Alert color="danger" className="mb-3">
//                             {formError}
//                         </Alert>
//                     )}
//                     <Form onSubmit={handleSubmit}>
//                         <Row className="g-3">
//                             <Col md={8}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Name *</Label>
//                                     <Input
//                                         type="text"
//                                         name="name"
//                                         value={formData.name}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         placeholder="e.g. Annual Leave"
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={4}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Short Name</Label>
//                                     <Input
//                                         type="text"
//                                         name="short_name"
//                                         value={formData.short_name}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         maxLength={20}
//                                         placeholder="e.g. AL"
//                                     />
//                                 </FormGroup>
//                             </Col>

//                             <Col md={4}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Color</Label>
//                                     <Input
//                                         type="color"
//                                         name="color_hex"
//                                         value={formData.color_hex}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         style={{ height: 34, padding: 2 }}
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={4}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Max Days / Year</Label>
//                                     <Input
//                                         type="number"
//                                         name="max_days_per_year"
//                                         value={formData.max_days_per_year as any}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         step="0.5"
//                                         min="0"
//                                         placeholder="Optional"
//                                     />
//                                 </FormGroup>
//                             </Col>
//                             <Col md={4}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Sort Order</Label>
//                                     <Input
//                                         type="number"
//                                         name="sort_order"
//                                         value={formData.sort_order}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         min="0"
//                                     />
//                                 </FormGroup>
//                             </Col>

//                             <Col md={12}>
//                                 <FormGroup>
//                                     <Label className="form-label-sm">Description</Label>
//                                     <Input
//                                         type="textarea"
//                                         name="description"
//                                         value={formData.description}
//                                         onChange={handleInputChange}
//                                         bsSize="sm"
//                                         rows={2}
//                                         placeholder="Enter description (optional)"
//                                     />
//                                 </FormGroup>
//                             </Col>

//                             <Col md={12}>
//                                 <div className="d-flex flex-wrap gap-4">
//                                     <FormGroup check className="mb-0">
//                                         <Label check>
//                                             <Input
//                                                 type="checkbox"
//                                                 name="is_paid"
//                                                 checked={formData.is_paid}
//                                                 onChange={handleInputChange}
//                                             />
//                                             <span className="ms-2">Paid</span>
//                                         </Label>
//                                     </FormGroup>
//                                     <FormGroup check className="mb-0">
//                                         <Label check>
//                                             <Input
//                                                 type="checkbox"
//                                                 name="carry_forward"
//                                                 checked={formData.carry_forward}
//                                                 onChange={handleInputChange}
//                                             />
//                                             <span className="ms-2">Carry Forward</span>
//                                         </Label>
//                                     </FormGroup>
//                                     <FormGroup check className="mb-0">
//                                         <Label check>
//                                             <Input
//                                                 type="checkbox"
//                                                 name="requires_approval"
//                                                 checked={formData.requires_approval}
//                                                 onChange={handleInputChange}
//                                             />
//                                             <span className="ms-2">Requires Approval</span>
//                                         </Label>
//                                     </FormGroup>
//                                     <FormGroup check className="mb-0">
//                                         <Label check>
//                                             <Input
//                                                 type="checkbox"
//                                                 name="requires_attachment"
//                                                 checked={formData.requires_attachment}
//                                                 onChange={handleInputChange}
//                                             />
//                                             <span className="ms-2">Requires Attachment</span>
//                                         </Label>
//                                     </FormGroup>
//                                     <FormGroup check className="mb-0">
//                                         <Label check>
//                                             <Input
//                                                 type="checkbox"
//                                                 name="is_active"
//                                                 checked={formData.is_active}
//                                                 onChange={handleInputChange}
//                                             />
//                                             <span className="ms-2">Active</span>
//                                         </Label>
//                                     </FormGroup>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Form>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="light" onClick={closeModal} disabled={submitting}>
//                         Cancel
//                     </Button>
//                     <Button color="primary" onClick={handleSubmit} disabled={submitting}>
//                         {submitting ? (
//                             <>
//                                 <Spinner size="sm" className="me-2" />
//                                 Saving...
//                             </>
//                         ) : modalMode === 'add' ? (
//                             'Create'
//                         ) : (
//                             'Update'
//                         )}
//                     </Button>
//                 </ModalFooter>
//             </Modal>

//             {/* Delete Confirmation Modal */}
//             <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
//                 <ModalHeader toggle={() => setDeleteModal(false)}>
//                     Confirm Delete
//                 </ModalHeader>
//                 <ModalBody>
//                     <p>
//                         Are you sure you want to delete the leave type{' '}
//                         <strong>"{leaveTypeToDelete?.name}"</strong>?
//                     </p>
//                     <Alert color="warning" className="mb-0">
//                         <i className="ri-alert-line me-2"></i>
//                         This action will deactivate the leave type. You can restore it later.
//                     </Alert>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button
//                         color="light"
//                         onClick={() => setDeleteModal(false)}
//                         disabled={deleting}
//                     >
//                         Cancel
//                     </Button>
//                     <Button color="danger" onClick={confirmDelete} disabled={deleting}>
//                         {deleting ? (
//                             <>
//                                 <Spinner size="sm" className="me-2" />
//                                 Deleting...
//                             </>
//                         ) : (
//                             'Delete'
//                         )}
//                     </Button>
//                 </ModalFooter>
//             </Modal>

//             {/* View Modal */}
//             <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
//                 <ModalHeader toggle={() => setViewModal(false)}>
//                     Leave Type Details
//                 </ModalHeader>
//                 <ModalBody>
//                     {viewingLeaveType && (
//                         <div>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Name:</strong>
//                                 </Col>
//                                 <Col md={8}>{viewingLeaveType.name}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Short Name:</strong>
//                                 </Col>
//                                 <Col md={8}>{viewingLeaveType.short_name || '—'}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Paid:</strong>
//                                 </Col>
//                                 <Col md={8}>{getPaidBadge(viewingLeaveType.is_paid)}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Color:</strong>
//                                 </Col>
//                                 <Col md={8}>{getColorSwatch(viewingLeaveType.color_hex)}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Max Days / Year:</strong>
//                                 </Col>
//                                 <Col md={8}>
//                                     {formatDecimal(viewingLeaveType.max_days_per_year)}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Carry Forward:</strong>
//                                 </Col>
//                                 <Col md={8}>
//                                     {viewingLeaveType.carry_forward ? 'Yes' : 'No'}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Requires Approval:</strong>
//                                 </Col>
//                                 <Col md={8}>
//                                     {viewingLeaveType.requires_approval ? 'Yes' : 'No'}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Requires Attachment:</strong>
//                                 </Col>
//                                 <Col md={8}>
//                                     {viewingLeaveType.requires_attachment ? 'Yes' : 'No'}
//                                 </Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Sort Order:</strong>
//                                 </Col>
//                                 <Col md={8}>{viewingLeaveType.sort_order ?? 0}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Status:</strong>
//                                 </Col>
//                                 <Col md={8}>{getStatusBadge(viewingLeaveType.is_active)}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Description:</strong>
//                                 </Col>
//                                 <Col md={8}>{viewingLeaveType.description || '—'}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Created At:</strong>
//                                 </Col>
//                                 <Col md={8}>{formatDate(viewingLeaveType.created_at)}</Col>
//                             </Row>
//                             <Row className="mb-3">
//                                 <Col md={4}>
//                                     <strong>Updated At:</strong>
//                                 </Col>
//                                 <Col md={8}>{formatDate(viewingLeaveType.updated_at)}</Col>
//                             </Row>
//                         </div>
//                     )}
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="secondary" onClick={() => setViewModal(false)}>
//                         Close
//                     </Button>
//                     {viewingLeaveType && (
//                         <Button
//                             color="primary"
//                             onClick={() => {
//                                 setViewModal(false);
//                                 openEditModal(viewingLeaveType);
//                             }}
//                         >
//                             <Edit size={14} className="me-1" />
//                             Edit
//                         </Button>
//                     )}
//                 </ModalFooter>
//             </Modal>
//         </div>
//     );
// };

// export default LeaveTypeMaster;

// src/pages/LeaveTypeMaster.tsx
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Button,
    Badge,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    Spinner,
} from 'reactstrap';
import {
    Plus,
    Edit,
    Trash2,
    RefreshCw,
    Eye,
    CheckCircle,
    XCircle,
} from 'react-feather';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import TableContainer from '../../Components/Common/TableContainer';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { apiClient } from '../../helpers/api_helper';

// Types
interface LeaveType {
    id: number;
    name: string;
    short_name?: string;
    color_hex?: string;
    carry_forward: boolean;
    requires_approval: boolean;
    requires_attachment: boolean;
    is_active: boolean;
    sort_order: number;
    description?: string;
    created_at: string;
    updated_at: string;
}

const LeaveTypeMaster: React.FC = () => {
    // State
    const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showInactive, setShowInactive] = useState(false);

    // Modal states
    const [modal, setModal] = useState(false);
    const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
    const [selectedLeaveType, setSelectedLeaveType] = useState<LeaveType | null>(null);
    const [formData, setFormData] = useState({
        name: '',
        short_name: '',
        color_hex: '#3B82F6',
        carry_forward: false,
        requires_approval: true,
        requires_attachment: false,
        is_active: true,
        sort_order: 0,
        description: '',
    });
    const [submitting, setSubmitting] = useState(false);
    const [formError, setFormError] = useState('');

    // Delete modal
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [leaveTypeToDelete, setLeaveTypeToDelete] = useState<LeaveType | null>(null);

    // View modal
    const [viewModal, setViewModal] = useState(false);
    const [viewingLeaveType, setViewingLeaveType] = useState<LeaveType | null>(null);

    // Fetch leave types
    const fetchLeaveTypes = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const response = await apiClient.get(
                `/leave-types?include_inactive=${showInactive}`
            );
            console.log('leave types', response);
            const data = response as LeaveType[];
            setLeaveTypes(data || []);
        } catch (error: any) {
            console.error('Error fetching leave types:', error);
            setError(error.message || 'Failed to fetch leave types');
            toast.error('Failed to load leave types');
        } finally {
            setLoading(false);
        }
    }, [showInactive]);

    // Initial fetch
    useEffect(() => {
        fetchLeaveTypes();
    }, [fetchLeaveTypes]);

    // Handle form input change
    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target;
        const checked = (e.target as HTMLInputElement).checked;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    // Open add modal
    const openAddModal = () => {
        setModalMode('add');
        setFormData({
            name: '',
            short_name: '',
            color_hex: '#3B82F6',
            carry_forward: false,
            requires_approval: true,
            requires_attachment: false,
            is_active: true,
            sort_order: 0,
            description: '',
        });
        setFormError('');
        setModal(true);
    };

    // Open edit modal
    const openEditModal = (leaveType: LeaveType) => {
        setModalMode('edit');
        setSelectedLeaveType(leaveType);
        setFormData({
            name: leaveType.name,
            short_name: leaveType.short_name || '',
            color_hex: leaveType.color_hex || '#3B82F6',
            carry_forward: leaveType.carry_forward,
            requires_approval: leaveType.requires_approval,
            requires_attachment: leaveType.requires_attachment,
            is_active: leaveType.is_active,
            sort_order: leaveType.sort_order ?? 0,
            description: leaveType.description || '',
        });
        setFormError('');
        setModal(true);
    };

    // Close modal
    const closeModal = () => {
        setModal(false);
        setSelectedLeaveType(null);
        setFormError('');
    };

    // Handle form submit
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Validate
        if (!formData.name.trim()) {
            setFormError('Leave type name is required');
            return;
        }

        setSubmitting(true);
        setFormError('');

        const payload = {
            name: formData.name.trim(),
            short_name: formData.short_name.trim() || undefined,
            color_hex: formData.color_hex?.trim() || undefined,
            carry_forward: formData.carry_forward,
            requires_approval: formData.requires_approval,
            requires_attachment: formData.requires_attachment,
            is_active: formData.is_active,
            sort_order: Number(formData.sort_order) || 0,
            description: formData.description.trim() || undefined,
        };

        try {
            if (modalMode === 'add') {
                await apiClient.post('/leave-types', payload);
                toast.success('Leave type created successfully!');
            } else {
                await apiClient.put(
                    `/leave-types/${selectedLeaveType?.id}`,
                    payload
                );
                toast.success('Leave type updated successfully!');
            }

            closeModal();
            fetchLeaveTypes();
        } catch (error: any) {
            console.error('Error saving leave type:', error);
            setFormError(error.message || 'Failed to save leave type');
            toast.error('Failed to save leave type');
        } finally {
            setSubmitting(false);
        }
    };

    // Handle delete
    const openDeleteModal = (leaveType: LeaveType) => {
        setLeaveTypeToDelete(leaveType);
        setDeleteModal(true);
    };

    const confirmDelete = async () => {
        if (!leaveTypeToDelete) return;

        setDeleting(true);
        try {
            await apiClient.delete(`/leave-types/${leaveTypeToDelete.id}`);
            toast.success('Leave type deleted successfully!');
            setDeleteModal(false);
            fetchLeaveTypes();
        } catch (error: any) {
            console.error('Error deleting leave type:', error);
            toast.error(error.message || 'Failed to delete leave type');
        } finally {
            setDeleting(false);
            setLeaveTypeToDelete(null);
        }
    };

    // Handle restore
    const handleRestore = async (leaveType: LeaveType) => {
        try {
            await apiClient.patch(`/leave-types/${leaveType.id}/restore`);
            toast.success('Leave type restored successfully!');
            fetchLeaveTypes();
        } catch (error: any) {
            console.error('Error restoring leave type:', error);
            toast.error(error.message || 'Failed to restore leave type');
        }
    };

    // Handle view
    const handleView = (leaveType: LeaveType) => {
        setViewingLeaveType(leaveType);
        setViewModal(true);
    };

    // Format date
    const formatDate = (dateString: string) => {
        try {
            return format(new Date(dateString), 'dd MMM yyyy HH:mm');
        } catch {
            return 'N/A';
        }
    };

    // Status badge (is_active)
    const getStatusBadge = (isActive: boolean) => {
        return isActive ? (
            <Badge color="success">
                <CheckCircle size={12} className="me-1" />
                Active
            </Badge>
        ) : (
            <Badge color="warning">
                <XCircle size={12} className="me-1" />
                Inactive
            </Badge>
        );
    };

    // Color swatch
    const getColorSwatch = (hex?: string) => {
        if (!hex) return '—';
        return (
            <div className="d-flex align-items-center gap-2">
                <span
                    style={{
                        display: 'inline-block',
                        width: 18,
                        height: 18,
                        borderRadius: 4,
                        backgroundColor: hex,
                        border: '1px solid rgba(0,0,0,0.15)',
                    }}
                />
                <span className="text-muted small">{hex}</span>
            </div>
        );
    };

    // Table columns
    const columns = useMemo(
        () => [
            {
                header: 'SI.No',
                accessorKey: 'id',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => <strong>{cell.row.index + 1}</strong>,
            },
            {
                header: 'Name',
                accessorKey: 'name',
                cell: (cell: any) => (
                    <span className="fw-semibold">{cell.getValue()}</span>
                ),
            },
            {
                header: 'Short',
                accessorKey: 'short_name',
                cell: (cell: any) => cell.getValue() || '—',
            },
            {
                header: 'Color',
                accessorKey: 'color_hex',
                enableColumnFilter: false,
                cell: (cell: any) => getColorSwatch(cell.getValue()),
            },
            {
                header: 'Carry Forward',
                accessorKey: 'carry_forward',
                cell: (cell: any) =>
                    cell.getValue() ? (
                        <Badge color="success">Yes</Badge>
                    ) : (
                        <Badge color="secondary">No</Badge>
                    ),
            },
            {
                header: 'Status',
                accessorKey: 'is_active',
                cell: (cell: any) => getStatusBadge(cell.getValue()),
            },
            {
                header: 'Actions',
                accessorKey: 'actions',
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    const leaveType = cell.row.original;
                    return (
                        <div className="d-flex gap-1">
                            <Button
                                color="info"
                                size="sm"
                                title="View"
                                onClick={() => handleView(leaveType)}
                            >
                                <Eye size={14} />
                            </Button>
                            <Button
                                color="primary"
                                size="sm"
                                title="Edit"
                                onClick={() => openEditModal(leaveType)}
                            >
                                <Edit size={14} />
                            </Button>
                            {leaveType.is_active ? (
                                <Button
                                    color="danger"
                                    size="sm"
                                    title="Delete"
                                    onClick={() => openDeleteModal(leaveType)}
                                >
                                    <Trash2 size={14} />
                                </Button>
                            ) : (
                                <Button
                                    color="success"
                                    size="sm"
                                    title="Restore"
                                    onClick={() => handleRestore(leaveType)}
                                >
                                    <RefreshCw size={14} />
                                </Button>
                            )}
                        </div>
                    );
                },
            },
        ],
        []
    );

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Leave Type Master" pageTitle="Leave Types" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h5 className="card-title mb-0">Leave Types</h5>
                                <div className="d-flex gap-2">
                                    <FormGroup check className="mb-0 d-flex align-items-center">
                                        <Label check className="me-2 mb-0">
                                            <Input
                                                type="checkbox"
                                                checked={showInactive}
                                                onChange={() =>
                                                    setShowInactive(!showInactive)
                                                }
                                            />
                                            <span className="ms-1">Show Inactive</span>
                                        </Label>
                                    </FormGroup>
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={() => fetchLeaveTypes()}
                                        disabled={loading}
                                    >
                                        <RefreshCw size={14} className="me-1" />
                                        Refresh
                                    </Button>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        onClick={openAddModal}
                                    >
                                        <Plus size={14} className="me-1" />
                                        Add Leave Type
                                    </Button>
                                </div>
                            </CardHeader>

                            <CardBody>
                                {error && (
                                    <Alert color="danger" className="mb-3">
                                        <i className="ri-error-warning-line align-middle me-2"></i>
                                        {error}
                                    </Alert>
                                )}

                                {loading ? (
                                    <div className="text-center py-5">
                                        <Spinner color="primary" className="me-2" />
                                        <span>Loading leave types...</span>
                                    </div>
                                ) : leaveTypes.length === 0 ? (
                                    <div className="text-center py-5">
                                        <i className="ri-calendar-check-line display-4 text-muted"></i>
                                        <h5 className="mt-3">No leave types found</h5>
                                        <p className="text-muted">
                                            {showInactive
                                                ? 'No leave types match your filter criteria.'
                                                : "Click 'Add Leave Type' to create your first leave type."}
                                        </p>
                                    </div>
                                ) : (
                                    <TableContainer
                                        columns={columns}
                                        data={leaveTypes}
                                        customPageSize={10}
                                        tableClass="table-striped"
                                        theadClass="table-light"
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Add/Edit Modal */}
            <Modal isOpen={modal} toggle={closeModal} size="lg">
                <ModalHeader toggle={closeModal}>
                    {modalMode === 'add' ? 'Add New Leave Type' : 'Edit Leave Type'}
                </ModalHeader>
                <ModalBody>
                    {formError && (
                        <Alert color="danger" className="mb-3">
                            {formError}
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3">
                            <Col md={8}>
                                <FormGroup>
                                    <Label className="form-label-sm">Name *</Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        bsSize="sm"
                                        placeholder="e.g. Annual Leave"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label className="form-label-sm">Short Name</Label>
                                    <Input
                                        type="text"
                                        name="short_name"
                                        value={formData.short_name}
                                        onChange={handleInputChange}
                                        bsSize="sm"
                                        maxLength={20}
                                        placeholder="e.g. AL"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label-sm">Color</Label>
                                    <Input
                                        type="color"
                                        name="color_hex"
                                        value={formData.color_hex}
                                        onChange={handleInputChange}
                                        bsSize="sm"
                                        style={{ height: 34, padding: 2 }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label className="form-label-sm">Sort Order</Label>
                                    <Input
                                        type="number"
                                        name="sort_order"
                                        value={formData.sort_order}
                                        onChange={handleInputChange}
                                        bsSize="sm"
                                        min="0"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <FormGroup>
                                    <Label className="form-label-sm">Description</Label>
                                    <Input
                                        type="textarea"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        bsSize="sm"
                                        rows={2}
                                        placeholder="Enter description (optional)"
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={12}>
                                <div className="d-flex flex-wrap gap-4">
                                    <FormGroup check className="mb-0">
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                name="carry_forward"
                                                checked={formData.carry_forward}
                                                onChange={handleInputChange}
                                            />
                                            <span className="ms-2">Carry Forward</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="mb-0">
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                name="requires_approval"
                                                checked={formData.requires_approval}
                                                onChange={handleInputChange}
                                            />
                                            <span className="ms-2">Requires Approval</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="mb-0">
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                name="requires_attachment"
                                                checked={formData.requires_attachment}
                                                onChange={handleInputChange}
                                            />
                                            <span className="ms-2">Requires Attachment</span>
                                        </Label>
                                    </FormGroup>
                                    <FormGroup check className="mb-0">
                                        <Label check>
                                            <Input
                                                type="checkbox"
                                                name="is_active"
                                                checked={formData.is_active}
                                                onChange={handleInputChange}
                                            />
                                            <span className="ms-2">Active</span>
                                        </Label>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={closeModal} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleSubmit} disabled={submitting}>
                        {submitting ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Saving...
                            </>
                        ) : modalMode === 'add' ? (
                            'Create'
                        ) : (
                            'Update'
                        )}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
                <ModalHeader toggle={() => setDeleteModal(false)}>
                    Confirm Delete
                </ModalHeader>
                <ModalBody>
                    <p>
                        Are you sure you want to delete the leave type{' '}
                        <strong>"{leaveTypeToDelete?.name}"</strong>?
                    </p>
                    <Alert color="warning" className="mb-0">
                        <i className="ri-alert-line me-2"></i>
                        This action will deactivate the leave type. You can restore it later.
                    </Alert>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="light"
                        onClick={() => setDeleteModal(false)}
                        disabled={deleting}
                    >
                        Cancel
                    </Button>
                    <Button color="danger" onClick={confirmDelete} disabled={deleting}>
                        {deleting ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                Deleting...
                            </>
                        ) : (
                            'Delete'
                        )}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* View Modal */}
            <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg">
                <ModalHeader toggle={() => setViewModal(false)}>
                    Leave Type Details
                </ModalHeader>
                <ModalBody>
                    {viewingLeaveType && (
                        <div>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Name:</strong>
                                </Col>
                                <Col md={8}>{viewingLeaveType.name}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Short Name:</strong>
                                </Col>
                                <Col md={8}>{viewingLeaveType.short_name || '—'}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Color:</strong>
                                </Col>
                                <Col md={8}>{getColorSwatch(viewingLeaveType.color_hex)}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Carry Forward:</strong>
                                </Col>
                                <Col md={8}>
                                    {viewingLeaveType.carry_forward ? 'Yes' : 'No'}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Requires Approval:</strong>
                                </Col>
                                <Col md={8}>
                                    {viewingLeaveType.requires_approval ? 'Yes' : 'No'}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Requires Attachment:</strong>
                                </Col>
                                <Col md={8}>
                                    {viewingLeaveType.requires_attachment ? 'Yes' : 'No'}
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Sort Order:</strong>
                                </Col>
                                <Col md={8}>{viewingLeaveType.sort_order ?? 0}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Status:</strong>
                                </Col>
                                <Col md={8}>{getStatusBadge(viewingLeaveType.is_active)}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Description:</strong>
                                </Col>
                                <Col md={8}>{viewingLeaveType.description || '—'}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Created At:</strong>
                                </Col>
                                <Col md={8}>{formatDate(viewingLeaveType.created_at)}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <strong>Updated At:</strong>
                                </Col>
                                <Col md={8}>{formatDate(viewingLeaveType.updated_at)}</Col>
                            </Row>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setViewModal(false)}>
                        Close
                    </Button>
                    {viewingLeaveType && (
                        <Button
                            color="primary"
                            onClick={() => {
                                setViewModal(false);
                                openEditModal(viewingLeaveType);
                            }}
                        >
                            <Edit size={14} className="me-1" />
                            Edit
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default LeaveTypeMaster;